import { Component, OnInit, Inject, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MyteamsService } from './../_services/myteams.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-weekMetrix',
  templateUrl: './weekMetrix.component.html',
  styleUrls: ['./weekMetrix.component.scss']
})
export class WeekMetrixComponent implements OnInit {
  isMobile = false;
  weekData : any = [];
  weekMetrix : any = [];
  lgmData : any = {};
  //WeekList  = Array.from(Array(17).keys());
  WeekList  = [];
  playerURL = `${environment.assetURL}/assets/uploads/players/`;
  constructor(public MyteamsService: MyteamsService,private spinner: NgxSpinnerService, private deviceService: DeviceDetectorService, public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) private data) {
    this.lgmData = data.lgmData;
    this.isMobile = this.deviceService.isMobile();
  }

  ngOnInit() {
    this.getWeekMtrixData();
  }

  ngOnChanges(e) {
    // need to detect input changes for user, parentPage
  }

  getWeekMtrixData(){
    this.spinner.show();
    this.MyteamsService.getWeekMatrix(this.lgmData.lgm_id,this.lgmData.game_id).subscribe(data=>{
      if(data['status'] == true) {
        this.weekData = data['entities'];
        let weekTotal = [];
        /**Check whether current week's data available or not? */
        if(this.lgmData.weekSlider.length == this.weekData.length + 1) {
          const currentWeek = Number(this.lgmData.weekSlider.at(-1).value.replace("week_",""));
          this.weekData.push({players:this.lgmData.players, lgm_id: this.lgmData.lgm_id, week :currentWeek, weekly_points: {t: this.lgmData.team_total, w: this.lgmData.this_week, r: (this.lgmData._tour_id > 0) ? this.lgmData.tour_rank : this.lgmData.team_rank }});
        }
        this.lgmData.players.forEach(element => {
          this.weekMetrix.push({"rp":element.pick_rp, "name": element.fn + ' ' +element.ln, "weeks": [], "total": 0,"pic":element.pic,"colorcode":this.getRGBAColor(element.color_code)});
          /**Create week metrix */
          this.lgmData.weekSlider.forEach(weekObject => {
            /**Get numerical value of week */
            const week = Number(weekObject.value.replace("week_",""));
            if(this.WeekList.indexOf(week) == -1) {
              /**Create week array */
              this.WeekList.push(week);
            }
            if(weekTotal[week] == null) weekTotal[week] = [];
            const thisweek = this.weekData.filter(elem => elem.week == week);
            if(thisweek.length > 0) {
              const players = thisweek[0].players.filter(val => val.id == element.id);
              if(players.length > 0) {
                if(players[0].use == true) weekTotal[week].push(Number(players[0].fpts));
                players[0].fpts = Number(players[0].fpts);
                this.weekMetrix[this.weekMetrix.length - 1].weeks.push(players[0]);
              } else {
                this.weekMetrix[this.weekMetrix.length - 1].weeks.push({"id": 0,"fpts": 0,"use": false,"result": []});
              }
            } else {
              this.weekMetrix[this.weekMetrix.length - 1].weeks.push({"id": 0,"fpts": 0,"use": false,"result": []});
            }
          });
          const usedPlayer = this.weekMetrix[this.weekMetrix.length - 1].weeks.filter(elem => elem.use == true);
          const sum = usedPlayer.reduce((partialSum, a) => partialSum + a.fpts, 0);
          this.weekMetrix[this.weekMetrix.length - 1].total = sum;
        });
        weekTotal =  weekTotal.map(myelem =>myelem.reduce((partialSum, a) => partialSum + a, 0));
        const finalTotal = weekTotal.reduce((partialSum, a) => partialSum + a, 0);
        if(finalTotal - this.lgmData.team_total > 0.1 || finalTotal - this.lgmData.team_total < -0.1) {
          this.MyteamsService.trackMismatch(this.lgmData.lgm_id).subscribe(data=>{});
        }
        weekTotal = weekTotal.filter(el => el != null);
        this.weekMetrix.push({"rp":"","name": "Total", "weeks": weekTotal, "total": finalTotal, "pic" : ""});
      }
      this.spinner.hide();
    });
  }

  prettyPrint(number) {
    const rem = number % 100;
    if (rem > 10 && rem < 21) {
      return number + 'th';
    } else {
      const rem2 = number % 10;
      if (rem2 == 1) return number + 'st';
      if (rem2 == 2) return number + 'nd';
      if (rem2 == 3) return number + 'rd';
      return number + 'th';
    }
  }
  getRGBAColor(color) {
    return 'rgba(' + parseInt('0x' + color.substr(1, 2), 16) + ',' + parseInt('0x' + color.substr(3, 2), 16) + ',' + parseInt('0x' + color.substr(5, 2), 16) + ',' + color.substr(8) + ')';
  }
}
